export interface UserRoleInfoType {
    id?: number;
    contact_id?: number;
    user_role_id?: number;
    display_role_name?: string;
    created_at?: string;
    updated_at?: string;
    role_name?: string;
}

// to single object maping
export const mapUserRoleInfoType = (data: any): UserRoleInfoType => {
    if (!data) {
        throw new Error('Invalid Data')
    }
    const res: UserRoleInfoType = {
        id: data.id,
        contact_id: data.contact_id,
        user_role_id: data.user_role_id,
        display_role_name: data.display_role_name,
        created_at: data.created_at,
        updated_at: data.updated_at,
        role_name: data.role_name,
    }
    return res;
}

// maping list objects
export const mapUserRoleInfoTypes = (data: any[]): UserRoleInfoType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }
    return data.map(mapUserRoleInfoType);
}
